import { LeadershipSection } from '@/components/sections/about-us/LeadershipSection';
import { DynamicLeadershipFragment } from '@/graphql/generated';

export const DynamicLeadershipBlock = ({ header, leaders }: DynamicLeadershipFragment) => {
  return <LeadershipSection leaders={leaders.data} header={header} />;
};
